/* Keep Shopify Inbox's native launcher and behavior; customize its visible label. */
(() => {
  const label = 'Chat for help!';
  const observed = new WeakSet();
  let scheduled = false;
  let startup;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }
  function observe(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
  }
  function sync() {
    const chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return;
    const shell = chat.shadowRoot;
    observe(shell);
    const runtime = shell.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot || shell;
    observe(root);
    const button = root.querySelector('button[part~="activator"]');
    if (!button) return;
    const text = button.querySelector('.activator__label');
    if (text && text.textContent !== label) text.textContent = label;
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    clearInterval(startup);
  }
  /* Inbox loads asynchronously; scoped observers handle its later re-renders. */
  const loader = new MutationObserver(() => { if (document.querySelector('shopify-chat')) { schedule(); } });
  loader.observe(document.body, { childList: true });
  startup = setInterval(sync, 250);
  setTimeout(() => { clearInterval(startup); loader.disconnect(); }, 30000);
  sync();
})();
